/**
 * Корюшковые — 4 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const КОРЮШКОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'smelt',
        семейство: 'корюшковые',
        latin: 'Osmerus eperlanus',
        повадка: 'холодолюбивый',
        minKg: 0.01,
        maxKg: 0.2,
        typicalKg: 0.04,
        typicalLengthM: 0.15,
        depthM: 5,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 15 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'spoon', вес: 0.2 },
        ],
    },
    {
        id: 'snetok',
        семейство: 'корюшковые',
        latin: 'Osmerus eperlanus spirinchus',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.05,
        typicalKg: 0.015,
        typicalLengthM: 0.09,
        depthM: 6,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 15 },
        течение: 'стоячая',
        держится: ['открытая_вода'],
        стая: 'большая_стая',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    // ── Восточная Азия ──
    {
        id: 'ayu',
        семейство: 'корюшковые',
        latin: 'Plecoglossus altivelis',
        повадка: 'стайная_бель',
        minKg: 0.02,
        maxKg: 0.25,
        typicalKg: 0.08,
        typicalLengthM: 0.22,
        depthM: 1,
        depthBandM: 0.8,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'одиночка',
        нерест: { с: 9, по: 11 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'wakasagi',
        семейство: 'корюшковые',
        latin: 'Hypomesus nipponensis',
        повадка: 'мелочь',
        minKg: 0.003,
        maxKg: 0.03,
        typicalKg: 0.012,
        typicalLengthM: 0.1,
        depthM: 5,
        depthBandM: 4,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 10, макс: 20 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 2, по: 4 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=osmerids.js.map